import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    trainingModuleRequestList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    
    trainingModuleRequestDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const trainingModuleRequestSlice = createSlice({
  name: 'trainingModuleRequest',
  initialState,
  reducers: {
    getTrainingModuleRequestList: (state, action) => {
        state.trainingModuleRequestList.requesting = true;
        state.trainingModuleRequestList.error = null;
        state.trainingModuleRequestList.items = [];
        state.trainingModuleRequestList.success = false;
        state.trainingModuleRequestList.filters = action.payload;
    },
    getTrainingModuleRequestListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.trainingModuleRequestList.requesting = false;        
        state.trainingModuleRequestList.items = data;
        state.trainingModuleRequestList.success = true; 
        state.trainingModuleRequestList.pagination.current_page = current_page;
        state.trainingModuleRequestList.pagination.per_page = per_page;
        state.trainingModuleRequestList.pagination.total = total;
    },
    getTrainingModuleRequestListFail: (state, action) => {        
        state.trainingModuleRequestList.requesting = false;
        state.trainingModuleRequestList.error = action.payload;
    },
    getTrainingModuleRequestDetails: (state) => {
        state.trainingModuleRequestDetails.requesting = true;
        state.trainingModuleRequestDetails.error = null;
        state.trainingModuleRequestDetails.data = null;
        state.trainingModuleRequestDetails.success = false; 
    },
    getTrainingModuleRequestDetailsSuccess: (state, action) => {
        state.trainingModuleRequestDetails.requesting = false;
        state.trainingModuleRequestDetails.data = action.payload;
        state.trainingModuleRequestDetails.success = true; 
    },
    getTrainingModuleRequestDetailsFail: (state, action) => {        
        state.trainingModuleRequestDetails.requesting = false;
        state.trainingModuleRequestDetails.error = action.payload;
    },
    doTrainingModuleRequestCreate: (state) => {
        state.trainingModuleRequestDetails.requesting = true;
        state.trainingModuleRequestDetails.error = null;
        state.trainingModuleRequestDetails.data = null;
        state.trainingModuleRequestDetails.success = false; 
    },
    doTrainingModuleRequestUpdate: (state) => {
        state.trainingModuleRequestDetails.requesting = true;
        state.trainingModuleRequestDetails.error = null;
        state.trainingModuleRequestDetails.data = null;
        state.trainingModuleRequestDetails.success = false; 
    },
    doTrainingModuleRequestDelete: (state) => {
        state.trainingModuleRequestDetails.requesting = true;
        state.trainingModuleRequestDetails.error = null;
        state.trainingModuleRequestDetails.data = null;
        state.trainingModuleRequestDetails.success = false; 
    },

    doTrainingModuleRequestReset: (state) => {		
      state.trainingModuleRequestDetails.data = null;
    },
  },
})

export const { 
    getTrainingModuleRequestList, getTrainingModuleRequestListSuccess, getTrainingModuleRequestListFail,
    getTrainingModuleRequestDetails, getTrainingModuleRequestDetailsSuccess, getTrainingModuleRequestDetailsFail,
    doTrainingModuleRequestCreate, doTrainingModuleRequestUpdate, doTrainingModuleRequestDelete,
    doTrainingModuleRequestReset,
} = trainingModuleRequestSlice.actions

export default trainingModuleRequestSlice.reducer